var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { v4 as uuid4 } from 'uuid';
import { customElement, property } from 'lit/decorators.js';
import Toolbar from 'devextreme/ui/toolbar';
import Drawer from 'devextreme/ui/drawer';
import { updateWhenLocaleChanges } from '@lit/localize';
import { DinapsisNavbarLogo } from './dinapsis-navbar-logo';
import { DinapsisNavbarDigitalServices } from './dinapsis-navbar-digital-services';
import { DinapsisNavbarSidebarMenu } from './dinapsis-navbar-sidebar-menu';
import { DinapsisNavbarUserMenu } from './dinapsis-navbar-user-menu';
import { NavbarMenuIcon } from './navbar-menu-icon';
import { DinapsisNavbarUserMenuIcon } from './dinapsis-navbar-user-menu-icon';
/**
 * Represents the navbar with the basic functionality for the main navbar
 */
let DinapsisNavbar = class DinapsisNavbar extends LitElement {
    constructor() {
        super();
        /**
         * Gets or sets the application name that is displayed in the navbar next to the icon
         */
        this.applicationName = 'servicios digitales';
        /**
         * Gets or sets the status of the sidenav menu
         */
        this.opened = false;
        /**
         * If it's true close all the menu options with children
         * By default all options are opened
         */
        this.closeAllAccordions = true;
        /**
         * Gets or sets the status of the user menu
         */
        this.openedMenuUser = false;
        /**
         * Gets or sets the sidenav menu items
         */
        this.menu = [];
        /**
         * Gets or sets the application logo
         */
        this.logo = '';
        /**
         * Gets or sets the digital services url
         */
        this.url = '';
        /**
         * Gets or sets the digital services visibility
         */
        this.visibility = '';
        /**
         * Gets or sets the application logo
         */
        this.containerId = 'main';
        /**
         * Gets or sets the height in px of toolbar
         */
        this.heightToolbar = 52;
        /**
         * A private variable for set min height in px toolbar
         */
        this.minHeightToolbar = 52;
        /**
         * A private variable for set the height in px toolbar style
         */
        this.heightToolbarStyle = `${this.heightToolbar}px`;
        /**
         * A private variable for set a random ID to the default container
         */
        this.randomId = uuid4();
        /**
         * A private variable for set a random ID to the default drawer container
         */
        this.drawerContainerId = `default-container-${this.randomId}`;
        /**
         * A private variable for set a random ID to the default user container
         */
        this.userContainerId = `user-container-${this.randomId}`;
        /**
         * A private variable for set a random ID to the default toolbar container
         */
        this.toolbarContainerId = `toolbar-${this.randomId}`;
        this.handleDocumentClick = (event) => {
            const clickedElement = event.target;
            const isUserMenuElement = clickedElement.closest('.menu-user-btn') !== null;
            if (!isUserMenuElement && this.openedMenuUser) {
                this.closeUserMenu();
            }
        };
        updateWhenLocaleChanges(this);
        // binds to access to ctx navbar context into classes
        this.toolbarTitle = this.toolbarTitle.bind(this);
        this.emitEvent = this.emitEvent.bind(this);
        this.openDrawer = this.openDrawer.bind(this);
        this.openUserMenu = this.openUserMenu.bind(this);
    }
    /**
     * This function is invoked after added to the DOM.
     * Override to disable de Shadow DOM and be able to apply the styles of Materializecss
     */
    createRenderRoot() {
        return this;
    }
    /**
     * The emitEvent function is called when a menu item is selected.
     * It dispatches a custom event called
     * 'click-menu' with the id of the selected menu item.
     * @param {any} evt - The event object that is passed to the event handler.
     */
    emitEvent(evt) {
        this.dispatchEvent(new CustomEvent('click-menu', { detail: evt.itemData.id }));
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('click', this.handleDocumentClick);
    }
    /**
     * If the locale is not set, then initialize the subcomponents.
     */
    firstUpdated() {
        var _a;
        this.updateHeightToolbar();
        this.drawerInstance = this.generateDrawerMenu();
        this.initSubComponents();
        if (this.opened)
            (_a = document.getElementById('menu-burger')) === null || _a === void 0 ? void 0 : _a.classList.add('open');
        if (this.closeAllAccordions) {
            this.menuListInstance.closeAccordions();
        }
        this.menuListInstance.setupTooltips();
        // https://lit.dev/docs/localization/runtime-mode/#example-of-using-the-status-event
        window.addEventListener('lit-localize-status', (event) => {
            // Catch when locale is ready to reload subComponents and update the locales
            if (event.detail.status === 'ready') {
                this.initSubComponents();
            }
        });
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('menu')) {
            const containerMenu = document.getElementById('containerMenu');
            const container = document.querySelector('.navbar-sidebar');
            containerMenu === null || containerMenu === void 0 ? void 0 : containerMenu.remove();
            const menuList = new DinapsisNavbarSidebarMenu(this.menu, this.emitEvent);
            container === null || container === void 0 ? void 0 : container.append(menuList.Render());
        }
    }
    /**
     * The render function is called when the component is first created
     * @returns The return value of the render() method is a template literal.
     */
    render() {
        return html `
      <div id="${this.toolbarContainerId}" class="toolbar" style="position: fixed; top: 0;"></div>
      <div id="${this.drawerContainerId}"></div>
      <div id="${this.userContainerId}"></div>
    `;
    }
    /**
     * Generate the Drawer
     * If the drawer instance is not null, then generate the toolbar.
     */
    initSubComponents() {
        if (this.drawerInstance) {
            this.generateToolbar();
        }
    }
    /**
     * A function to check if exist outside container or not
     * @returns Return True if exist a container outside and False if not found a container.
     */
    haveExternalContainer() {
        return Boolean(document.getElementById(this.containerId));
    }
    /**
     * This function return the application title html
     */
    toolbarTitle() {
        return `<img class="dinapsis-logo" style="height: ${this.heightToolbar}px; padding: 8px;"/>`;
    }
    /**
     * "Create a new Drawer instance, add a template to it, and return the instance."
     * The template is a div with a class of "navbar-sidebar".
     * The template contains a user logo, a menu list, and a user menu.
     * The user menu is only added if the keycloak property is set.
     * The user logo and menu list are created by calling the DinapsisNavbarLogo and
     * DinapsisNavbarSidebarMenu classes.
     * The user menu is created by calling the DinapsisNavbarUserMenu class.
     * The DinapsisNavbarLogo, DinapsisNavbarSidebarMenu, and DinapsisNavbarUserMenu classes are all
     * defined in the same file as the generateDrawerMenu function.
     * The DinapsisNavbarLog
     * @returns The result of the function is the drawerinstance.
     */
    generateDrawerMenu() {
        // Create Drawer Container
        const drawerContainer = this.generateDrawerContainer();
        let drawerinstance;
        if (drawerContainer) {
            drawerContainer.style.position = 'fixed';
            drawerContainer.style.height = `calc(100vh - ${this.heightToolbarStyle})`;
            drawerContainer.style.top = this.heightToolbarStyle;
            drawerinstance = new Drawer(drawerContainer);
            // add template container with menu list or user List
            drawerinstance.option('template', () => {
                const userLogo = new DinapsisNavbarLogo(this.logo);
                const menuList = new DinapsisNavbarSidebarMenu(this.menu, this.emitEvent);
                this.menuListInstance = menuList;
                // Drawer styles class
                const result = document.createElement('div');
                result.className = 'navbar-sidebar';
                // add clases html result into result div as a drawer template
                result.append(userLogo.Render());
                result.append(menuList.Render());
                return result;
            });
            return drawerinstance;
        }
        return null;
    }
    /**
     * If the user has provided an external container, return that container. Otherwise, return the
     * default container.
     * @returns the element with the id of the containerId or the default container id.
     */
    generateDrawerContainer() {
        const haveExternalContainer = this.haveExternalContainer();
        if (haveExternalContainer)
            return document.getElementById(this.containerId);
        return document.getElementById(`${this.drawerContainerId}`);
    }
    /**
     * This function creates a toolbar with a button and a title.
     */
    generateToolbar() {
        const idMenu = `menu-burger-${this.randomId}`;
        const buttonMenu = new NavbarMenuIcon(idMenu, this.openDrawer, this.opened);
        const btnDigitalServices = new DinapsisNavbarDigitalServices(this.url, this.visibility);
        const idUserMenu = `menu-user-${this.randomId}`;
        let menuUser;
        if (this.keycloak && this.keycloak.authenticated) {
            menuUser = new DinapsisNavbarUserMenuIcon(idUserMenu, this.openUserMenu, this.openedMenuUser, this.keycloak);
        }
        const container = document.getElementById(`${this.toolbarContainerId}`);
        if (container) {
            // eslint-disable-next-line no-new
            new Toolbar(container, {
                items: [
                    {
                        location: 'before',
                        locateInMenu: 'never',
                        template: () => buttonMenu.Render(),
                    },
                    {
                        location: 'before',
                        locateInMenu: 'never',
                        template: this.toolbarTitle(),
                    },
                    {
                        location: 'before',
                        locateInMenu: 'never',
                        template: () => btnDigitalServices.Render(),
                    },
                    {
                        location: 'after',
                        locateInMenu: 'never',
                        template: () => this.renderMenuUser(menuUser),
                    },
                ],
            });
            // Set height
            container.style.height = this.heightToolbarStyle;
        }
    }
    /**
     * If the drawerInstance is not null, then toggle the drawer.
     */
    openDrawer() {
        var _a;
        (_a = this.drawerInstance) === null || _a === void 0 ? void 0 : _a.toggle();
    }
    /**
     * open or close user menu.
     */
    openUserMenu() {
        if (this.keycloak && this.keycloak.authenticated) {
            const container = document.getElementById('main');
            if (!this.openedMenuUser) {
                if (container) {
                    const userMenu = new DinapsisNavbarUserMenu(this.keycloak);
                    container.append(userMenu.Render());
                    this.openedMenuUser = true;
                }
            }
            else {
                this.closeUserMenu();
            }
        }
    }
    renderMenuUser(menuUser) {
        let menuRender = null;
        if (this.keycloak && this.keycloak.authenticated) {
            menuRender = menuUser.Render();
        }
        return menuRender;
    }
    closeUserMenu() {
        const menu = document.getElementsByClassName('dinapsis-user-menu');
        // eslint-disable-next-line no-plusplus
        for (let i = menu.length - 1; i >= 0; --i) {
            menu[i].remove();
        }
        this.openedMenuUser = false;
    }
    updateHeightToolbar() {
        if (this.heightToolbar < this.minHeightToolbar) {
            this.heightToolbarStyle = `${this.minHeightToolbar}px`;
        }
        else {
            this.heightToolbarStyle = `${this.heightToolbar}px`;
        }
    }
};
__decorate([
    property({ type: String })
], DinapsisNavbar.prototype, "applicationName", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisNavbar.prototype, "opened", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisNavbar.prototype, "closeAllAccordions", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisNavbar.prototype, "openedMenuUser", void 0);
__decorate([
    property({ type: Array() })
], DinapsisNavbar.prototype, "menu", void 0);
__decorate([
    property({ type: Object })
], DinapsisNavbar.prototype, "keycloak", void 0);
__decorate([
    property({ type: String })
], DinapsisNavbar.prototype, "logo", void 0);
__decorate([
    property({ type: String })
], DinapsisNavbar.prototype, "url", void 0);
__decorate([
    property({ type: String })
], DinapsisNavbar.prototype, "visibility", void 0);
__decorate([
    property({ type: String })
], DinapsisNavbar.prototype, "containerId", void 0);
__decorate([
    property({ type: Number })
], DinapsisNavbar.prototype, "heightToolbar", void 0);
DinapsisNavbar = __decorate([
    customElement('dinapsis-navbar')
], DinapsisNavbar);
export { DinapsisNavbar };
//# sourceMappingURL=dinapsis-navbar.js.map